import { takeLatest, call, put, StrictEffect, cancel, delay, select } from 'redux-saga/effects';
import organization, {
    addClientToOrganization,
    addClientToOrganizationError,
    addClientToOrganizationSuccess,

    getOrganizationClients,
    getOrganizationClientsError,
    getOrganizationClientsSuccess,

    getOrganisationInvitations,
    getOrganisationInvitationsError,
    getOrganisationInvitationsSuccess,

    addClientToOrganizationViaEmailError,
    addClientToOrganizationViaEmail,
    addClientToOrganizationViaEmailSuccess,

    addClientOrganization,
    addClientOrganizationError,
    addClientOrganizationSuccess,

    giveAccessToOrganization,
    giveAccessToOrganizationSuccess,
    giveAccessToOrganizationError,

    removeAccessToOrganization,
    removeAccessToOrganizationError,
    removeAccessToOrganizationSuccess,

    updateUsersPermissions,
    updateUsersPermissionsError,
    updateUsersPermissionsSuccess,
    getOrganizationUsers,
    getOrganizationUsersSuccess,
    getOrganizationUsersError,
    acceptOrganisationInvitation,
    acceptOrganisationInvitationError,
    acceptOrganisationInvitationSuccess,
    declineOrganisationInvitation,
    declineOrganisationInvitationError,
    declineOrganisationInvitationSuccess,
    deleteClientFromOrganisation,
    deleteClientFromOrganisationError,
    deleteClientFromOrganisationSuccess,

    addUser,
    addUserSuccess,
    addUserError,

    removeUser,
    removeUserSuccess,
    removeUserError,

    getOrganizationSites,
    getOrganizationSitesError,
    getOrganizationSitesSuccess,

    createClientOrganization,
    createClientOrganizationSuccess,
    createClientOrganizationError,
    getClientOrganizationsError,
    getClientOrganizationsSuccess,
    getClientOrganizations,

    fetchClientSiteList,
    fetchClientSiteListSuccess,
    fetchClientSiteListError,

    _UpdateremoveAccessToOrganizationSagaSucess,
    UpdateremoveAccessToOrganizationSaga,
    currentUserOrganizationAuthSuccess,
    currentUserOrganizationAuthError,
    currentUserOrganizationAuth,
    deleteOrganizationfunSuccess,
    deleteOrganizationfunError,
    deleteOrganizationfun,
    fetchCompanies,
    fetchCompaniesSuccess,
    fetchCompaniesError,
    createCompanySuccess,
    createCompanyError,
    createCompany,
    inviteCompanyToOrganizationError,
    inviteCompanyToOrganizationSuccess,
    inviteCompanyToOrganization,
    getCompanyInvitationsToJoinOrganizationsSuccess,
    getCompanyInvitationsToJoinOrganizationsError,
    getCompanyInvitationsToJoinOrganizations,
    companyDeclinesInvetationSuccess,
    companyDeclinesInvetationError,
    companyDeclinesInvetation,
    companyAcceptInvetation,
    companyAcceptInvetationError,
    companyAcceptInvetationSuccess,
    getCompanyWebsies,
    getCompanyWebsiesSuccess,
    getCompanyWebsiesError,
    grantAccessToOrganizationSuccess,
    grantAccessToOrganizationError,
    grantAccessToOrganization,
    getJoinedOrganizationeError,
    getJoinedOrganizationSuccess,
    getJoinedOrganization,
    updateCompanyName,
    updateCompanyNameError,
    updateCompanyNameSuccess,
    getInfosIndustry,
    getInfoIndustrySuccess,
    getInfoIndustryError,
    updateInfosIndustry,
    updateInfoIndustryError,
    updateInfoIndustrySuccess,
    getOwnCompanies,
    getOwnCompaniesSuccess,
    getOwnCompaniesError,
    addCategorySuccess,
    addCategoryError,
    addCategory,
    updateCategorySuccess,
    updateCategoryError,
    updateCategory,
    deleteCategory,
    deleteCategorySuccess,
    deleteCategoryError,
    getOwnCompanyUsers,
    getOwnCompanyUsersSuccess,
    getOwnCompanyUsersError,
    removeUserFromCompany,
    removeUserFromCompanySuccess,
    removeUserFromCompanyError,
    assignComanyRole,
    assignComanyRoleSuccess,
    assignComanyRoleError,
    assignComanyPermission,
    assignComanyPermissionSuccess,
    assignComanyPermissionError,
    assignWebSitePermission,
    assignWebSitePermissionSuccess,
    assignWebSitePermissionError

} from './index';
import { PayloadAction } from '@reduxjs/toolkit';
import { apiInstance } from 'src/services/interceptor';
import { SagaIterator } from 'redux-saga';
import { Exception } from 'sass';
import { log } from 'console';
import {updateCurrentUserOrganizationInfo} from '../user/index' ;

interface PayloadProps {
    organisationId? : string;
    clientTenantId? : string;
    client_email? : string;
    organisation_id? : string;
    invitationId?: string;

    tenant_id? :string;
    role?:string;
    name?:string;

    tenantId?:string;
    organisation_admin_email? : string;
    organization_name:string;
    company_id:string ,

    submitCallback?: ()=>void;
    errorCallback?: (value:string)=>void;
    addSiteToCompany?:(data:any)=>void
}

function* addClientToOrganizationSaga({ payload: { organisationId, clientTenantId } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        const clientAddedToOrganization = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/client/add` , {
            organisationId,
            clientTenantId

        });
        if(clientAddedToOrganization?.data){
            yield put(addClientToOrganizationSuccess(clientAddedToOrganization.data));
            return;
        }
        yield put(addClientToOrganizationError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';

        yield put(addClientToOrganizationError(errorMessage));
    }
}

function* getOrganizationClientsSaga({ payload: { organisationId } }: PayloadAction<PayloadProps>): SagaIterator {
    try {
        const organisationCliens = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-organization-clients` , {
            organizationId : organisationId,
        });



        if(organisationCliens?.data){
            yield put(getOrganizationClientsSuccess(organisationCliens.data));
            return;
        }
        yield put(getOrganizationClientsError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';

        yield put(getOrganizationClientsError(errorMessage));
    }
}


// get invitations to organisation by tenantId
function* getOrganisationInvitationsSaga({ payload: { clientTenantId } }: PayloadAction<PayloadProps>): SagaIterator {
    try {
        const { organizationsId, userSelectedOrganization} = yield select((state) => state.user.data);
        let notifications:any = [];

        // if(profile_status == 'client'){
         
            // const clientNotifications = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-organization-companies-requests` , {
            //     clientTenantId,
            // });
            const userNotifications = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/organizations-invites/getall` , {
                userTenantId:clientTenantId,
            });            
            if ( userNotifications?.data) {

                const modifiedUserNotifications = userNotifications.data.map((notification: any ) => ({
                    ...notification,
                    inviteUser: true
                }));
                notifications = [ ...modifiedUserNotifications];
            }
            //  else if (clientNotifications?.data) {
            //     notifications = clientNotifications.data;
            // } else if (userNotifications?.data) {
            //     notifications = userNotifications.data.map((notification: any) => ({
            //         ...notification,
            //         inviteUser: true
            //     }));
            // }
            
        // }else{

        //     const organizationId = profile_status == 'organization' ? organizationsId : userSelectedOrganization;
        //     const orgNotifications = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-clients-requests` , {
        //         organizationId,
        //     });
        //     notifications = orgNotifications?.data;
        // }

        if(notifications){
            yield put(getOrganisationInvitationsSuccess(notifications));
            return;
        }
        yield put(getOrganisationInvitationsError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';

        yield put(getOrganisationInvitationsError(errorMessage));
    }
}

function* addClientToOrganizationUsingEmailSaga({ payload: { organisation_id, client_email } }: PayloadAction<PayloadProps>): SagaIterator {

    try {

        const clientAddedToOrganization = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/joinorganisation/invite` , {
            organisation_id ,
            client_email
        });
        if(clientAddedToOrganization?.data){
            yield put(addClientToOrganizationViaEmailSuccess(clientAddedToOrganization.data));

            const user = yield select((state) => state.user.data);
            yield put(getOrganizationClients({ organisationId : user?.organizationsId }));
            return;
        }
        yield put(addClientToOrganizationViaEmailError('error'));
    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(addClientToOrganizationViaEmailError('error'));
    }
}

//client request join an organiization
function*  requestToJoinOrganizationSaga({ payload: { company_id , organization_name } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        const organiization = yield call(apiInstance.post, `reporttool/organisationlevel/company/request-to-join-organization` , {
            // organisation_admin_email,
            // client_email
            company_id ,
            organization_name
        });


        if(organiization?.data){
            yield put(addClientOrganizationSuccess(organiization.data));
            const user = yield select((state) => state.user.data);

            yield put(getClientOrganizations({
                tenantId : user.tenantId
            }))
            return;
        }
        yield put(addClientOrganizationError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.error ?? 'error'; 
        yield put(addClientOrganizationError(errorMessage));
    }
}


// give Access To Organization
function* giveAccessToOrganizationSaga({ payload }: PayloadAction<any>): SagaIterator {
    try {

        const giveAccessStatus = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/give-access-to-organization` , {
            organizationId: payload.organizationId ,
            clientTenantId: payload.tenantId ,
            siteIds: payload.selectedWebsites ,
        });

        if(giveAccessStatus?.status == 200){
            yield put(giveAccessToOrganizationSuccess(giveAccessStatus.data));
            return;
        }
        yield put(giveAccessToOrganizationError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(giveAccessToOrganizationError(errorMessage));
    }
}

// remove Access To Organization
function* removeAccessToOrganizationSaga({ payload }: PayloadAction<any>): SagaIterator {
    try {

        const removeAccessStatus = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/remove-access-from-organization` , {
            organizationId: payload.organizationId ,
            clientTenantId: payload.tenantId ,
            siteIds: payload.siteToremove ,
        });

        if(removeAccessStatus?.status == 200){
            // const data = JSON.parse(removeAccessStatus)
            yield put(removeAccessToOrganizationSuccess( removeAccessStatus.data?.message ));
            return;
        }
        yield put(removeAccessToOrganizationError('Enable to Remove Access to Organization'));

    } catch (error: any) {

        console.log( error );
        
        const errorMessage = error?.response?.data?.message ??  error?.response?.data  ?? 'error';


        yield put(removeAccessToOrganizationError(errorMessage));
    }
}

    // Update users permissioms
    function* updateUsersPermissionsSaga({ payload }: PayloadAction<any>): SagaIterator {

        try {
           
            
            const updateUsersPermissionsStatus = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/update-users-permissions` , {
                organizationId: payload.organisationId,
                users: payload.userPermissions

            });
            if(updateUsersPermissionsStatus?.data?.statusCode == 200){
                // localStorage.removeItem('currentUserOrganizationInfo');
                yield put(updateUsersPermissionsSuccess(updateUsersPermissionsStatus.data.data));
                return;
            }
            yield put(updateUsersPermissionsError('error'));

        } catch (error: any) {
            const errorMessage = error.response?.data?.message ?? 'error';
            yield put(updateUsersPermissionsError(errorMessage));
        }
    }

        // get Organization Users
        function* getOrganizationUsersSaga({ payload }: PayloadAction<any>): SagaIterator {
            try {
                const organizationUsers = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-organization-users` , {
                    organizationId: payload,
                });

                if(organizationUsers?.status == 200){
                    yield put(getOrganizationUsersSuccess(organizationUsers.data));
                    return;
                }

            } catch (error: any) {
                const errorMessage = error.response?.data?.message ?? 'error';
                yield put(getOrganizationUsersError(errorMessage));
            }
        }

// accept organisation invitation by invitationId
function*  acceptOrganisationInvitationSaga({ payload: { invitationId,inviteUser } }: any ): SagaIterator {

    try {
        const endPoint = inviteUser ? 'organization-invite/accept' : 'joinorganisation/invite/accept';
        const invetation = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/${endPoint}` , {
            invitationId
        });
        if(invetation?.data){
            yield put(acceptOrganisationInvitationSuccess(invetation.data));
            const user = yield select((state) => state.user.data);
            if(inviteUser){
                let nUser = { ...user };
                nUser.isUser = true;
                yield put(updateCurrentUserOrganizationInfo({
                    data: nUser
                  }));
            }
            yield put(getOrganisationInvitations({ clientTenantId : user?.tenantId }))
            yield put(getClientOrganizations({
                tenantId : user.tenantId
            }))
            return;
        }
        yield put(acceptOrganisationInvitationError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';

        yield put(acceptOrganisationInvitationError(errorMessage));
    }
}
// accept organisation invitation by invitationId
function*  declineOrganisationInvitationSaga({ payload: { invitationId, inviteUser } }: any): SagaIterator {

    try {

        const endPoint = inviteUser ? 'organization-invite/decline' : 'joinorganisation/invite/decline';

        const invetation = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/${endPoint}` , {
            invitationId
        });
        if(invetation?.data){
            yield put(declineOrganisationInvitationSuccess(invetation.data));
            const user = yield select((state) => state.user.data);
            yield put(getOrganisationInvitations({ clientTenantId : user?.tenantId }));
            yield put(getClientOrganizations({
                tenantId : user.tenantId
            }))
            return;
        }
        yield put(declineOrganisationInvitationError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';

        yield put(declineOrganisationInvitationError(errorMessage));
    }
}

function*  deleteClientFromOrganisationSaga({ payload: { company_id } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        const client = yield call(apiInstance.post, `reporttool/usermanagement/user/leave-company` , {
            company_id
        });

        console.log('client?.data?.data');
        console.log(client?.data?.data);
        console.log('client?.data?.data');
        

        if(client?.data?.data){
            yield put(deleteClientFromOrganisationSuccess(client?.data?.data));
            return;
        }
        yield put(deleteClientFromOrganisationError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';

        yield put(deleteClientFromOrganisationError(errorMessage));
    }
}


           // add User Organization
           function* addUserSaga({ payload }: PayloadAction<any>): SagaIterator {
            try {
                const addUserStatus = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/invite-user-to-organization` , {
                    organization_id: payload.organization_id ,
                    user_email: payload.user_email
                });
                if(addUserStatus?.status == 200){
                    yield put(addUserSuccess(addUserStatus.data.user_ids));
                    return;
                }
                yield put(addUserError('error'));

            } catch (error: any) {
                const errorMessage = error.response?.data?.message ?? 'error';
                yield put(addUserError(errorMessage));
            }
        }

         // remove User from Organization
         function* removeUserSaga({ payload }: PayloadAction<any>): SagaIterator {
            try {
                const removeUserStatus = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/remove-user` , {
                    organizationId: payload.organizationId ,
                    userTenantId: payload.userTenantId
                });

                if(removeUserStatus?.status == 200){
                    yield put(removeUserSuccess(removeUserStatus.data));
                    return;
                }
                yield put(removeUserError('error'));

            } catch (error: any) {
                const errorMessage = error.response?.data?.message ?? 'error';
                yield put(removeUserError(errorMessage));
            }
        }

         // get Organization Sites
         function* getOrganizationSitesSaga({ payload }: PayloadAction<any>): SagaIterator {
            try {
                const organizationSite = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-organization-sites` , {
                    organizationId: payload ,
                });

                if(organizationSite?.status == 200){
                    yield put(getOrganizationSitesSuccess(organizationSite.data));
                    return;
                }

                yield put(getOrganizationSitesError('error'));

            } catch (error: any) {
                const errorMessage = error.response?.data?.message || 'error';
                yield put(getOrganizationSitesError(errorMessage));
            }
        }


function*  createOrganizationSaga({ payload: { tenant_id , name , submitCallback , errorCallback , addSiteToCompany  } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        const organization = yield call(apiInstance.post, `reporttool/usermanagement/company/create` , {
            tenant_id,
            company_name:name
        });

            
        if(organization?.data?.data){
            submitCallback?.();
            addSiteToCompany?.(organization?.data?.data)
            yield put(createClientOrganizationSuccess(organization.data.data));

        //    const authorized =  {
        //         hasOrganizations: true,
        //         organizationsId: organization?.data?.id,
        //         role: organization?.data.role,
        //         name,
        //         company_id : organization?.company_id
        //     };     
        //     const data = yield select((state) => state.user.data);
        //     let user = { ...data };
        //     user.hasOrganizations = true;
        //     yield put(updateCurrentUserOrganizationInfo({
        //         data: user
        //       }));

            // yield put(getClientOrganizations({ tenantId:tenant_id }));
            // yield put(currentUserOrganizationAuthSuccess(authorized));
            return;
        }

        const alertMessage = organization?.data?.message ?? `Enable to Create ${name}. Please Try Again Later.`
        yield put(createClientOrganizationError(alertMessage));
        errorCallback?.(alertMessage)
    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        errorCallback?.(errorMessage)
        yield put(createClientOrganizationError(errorMessage));
    }
}

// by client id get the organization of that client.
function*  getClientOrhanizations({ payload: { tenantId } }: PayloadAction<PayloadProps>): SagaIterator {
    
    try {

        let MyOrganizationDetails: any = [];

        MyOrganizationDetails = yield call(apiInstance.post, `reporttool/usermanagement/company/get-member-companies` );               
        if(MyOrganizationDetails?.data?.data){
            yield put(getClientOrganizationsSuccess(MyOrganizationDetails?.data?.data));
            return;
        }
        yield put(getClientOrganizationsError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';

        yield put(getClientOrganizationsError(errorMessage));
    }
}


         // get client Sites
         function* fetchSiteListSaga(): SagaIterator {
            try {
                const user = yield select((state) => state.user.data);
                const clientSites = yield call(apiInstance.get, `reporttool/site/${user.tenantId}`);
                if(clientSites?.status == 200){
                    yield put(fetchClientSiteListSuccess(clientSites.data));
                    return;
                }
                yield put(fetchClientSiteListError('error'));

            } catch (error: any) {
                const errorMessage = error.response?.data?.message ?? 'error';
                yield put(fetchClientSiteListError(errorMessage));
            }
        }

        function* _UpdateremoveAccessToOrganizationSaga(): SagaIterator {
            yield put(_UpdateremoveAccessToOrganizationSagaSucess());
        }
function* getCurrentUserOrganizationPermissionsSaga({ payload: { tenantId } }: PayloadAction<PayloadProps>): SagaIterator {
    let authorized = {
        hasOrganizations: false,
        organizationsId: "",
        role: "",
        name: ""
    };

    try {
        const response = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-organisation-details`, { tenantId });
        if (response?.data?.length > 0) {
            for (const data of response.data) {
                if (data?.tenant_id === tenantId) {
                    authorized = {
                        hasOrganizations: true,
                        organizationsId: data.id,
                        role: data.role,
                        name: data.name
                    };
                    break; // Breaks the loop when the matching tenant_id is found
                }
            }
            // console.log(`hasOrganizations`, authorized);
            yield put(currentUserOrganizationAuthSuccess(authorized));
        } else {
            // If no organizations found or data is empty
            // console.log('No organizations found for this tenant ID');
            yield put(currentUserOrganizationAuthSuccess(authorized));
        }
    } catch (error :any) {
        if (error.response && error.response.status === 404) {
            // Handle 404 specifically
            // console.log('No data available for the given tenant ID:', tenantId);
            yield put(currentUserOrganizationAuthSuccess(authorized));
        } else {
            // Handle other errors
            const errorMessage = error.response?.data?.message ?? 'Unknown error occurred';
            yield put(currentUserOrganizationAuthError(errorMessage));
        }
    }
}



function*  deleteOrganisationSaga({ payload: { company_id , errorCallback , submitCallback } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        // localStorage.removeItem('currentUserOrganizationInfo');
        const organization = yield call(apiInstance.delete, `reporttool/usermanagement/company`, {
            data: {
                company_id,
            }
          });
        if(organization?.data?.data){
            submitCallback?.();
            yield put(deleteOrganizationfunSuccess(organization?.data?.data));
            // const user = yield select((state) => state.user.data);
            yield put(getOwnCompanies())
            return;
        }
        errorCallback?.('Enable to delete This Company.Please Try Later.');
        yield put(deleteOrganizationfunError('error'));

    } catch (error: any) {
        const errorMessage = error?.response?.data || error?.response?.data?.message || 'error'
        errorCallback?.(errorMessage);
        yield put(deleteOrganizationfunError(errorMessage));
    }
}


function*  fetchCompaniesFunc({ payload: { organizationId } }: any): SagaIterator {

    try {
        const organization = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-organization-companies`, {
            organization_id : organizationId,
        });
        if(organization?.data){
            yield put(fetchCompaniesSuccess(organization.data));
            return;
        }
        yield put(fetchCompaniesError('error'));

    } catch (error: any) {
        console.log(error.response.data);

        const errorMessage = error.response.data || error.response?.data?.message || 'error'
        yield put(fetchCompaniesError(errorMessage));
    }
}

function* createUserCompanySaga({ payload: { tenant_id , company_name , submitCallback , errorCallback  } }: any): SagaIterator {

    try {
        const company = yield call(apiInstance.post, `reporttool/organisationlevel/company/create`, {
            tenant_id,
            company_name: company_name
        });

        if (company) {
            submitCallback?.(company?.data)
            yield put(createCompanySuccess(company?.data));
            return;
        }
        errorCallback?.()
        yield put(createCompanyError('error'));

    } catch (error: any) {
        console.log(error);
        errorCallback?.()
        yield put(createCompanyError('error'));
    }
}

function* inviteCompanyToOrganisationSaga({ payload }: any): SagaIterator {

    try {        
        const company = yield call(apiInstance.post, `reporttool/usermanagement/company/invite-user`, {
            user_email: payload.user_email,
            company_id: payload.company_id
        });
        if (company) {
            payload?.submitCallback?.()
            yield put(inviteCompanyToOrganizationSuccess(company?.data));
            return;
        }
        payload?.errorCallback?.('Enable to Invite User')
        yield put(inviteCompanyToOrganizationError('error'));

    } catch (error: any) {
        payload?.errorCallback?.('Enable to Invite User')
        yield put(inviteCompanyToOrganizationError('error'));
    }
}

// get-company-invitations-to-join-organizations
function* getCompanyInvitationToJoinOrganizationSaga({ payload: { company_id } }: any): SagaIterator {

    try {
        const invetations = yield call(apiInstance.post, `/reporttool/usermanagement/user/get-user-invitations`);
        if (invetations?.data?.data) {
            yield put(getCompanyInvitationsToJoinOrganizationsSuccess(invetations?.data?.data));
            return;
        }
        yield put(getCompanyInvitationsToJoinOrganizationsError('error'));

    } catch (error: any) {
        yield put(getCompanyInvitationsToJoinOrganizationsError('error'));
    }
}

//decline-organization-invitation

function* declineOrganizationInvitationSaga({ payload: { company_id , organization_id } }: any): SagaIterator {

    try {
        const invetations = yield call(apiInstance.post, `/reporttool/usermanagement/user/decline-company-invitation`, {
            company_id,
        });

        console.log('invetationsinvetationsinvetations');
        console.log(invetations);
        console.log('invetationsinvetationsinvetationsinvetations');
        if (invetations) {
            yield put(companyDeclinesInvetationSuccess(invetations?.data));
            yield put(getCompanyInvitationsToJoinOrganizations({
                company_id 
            }))
            return;
        }
        yield put(companyDeclinesInvetationError('error'));

    } catch (error: any) {
        yield put(companyDeclinesInvetationError('error'));
    }
}

function* acceptOrganizationInvitationSaga({ payload: { company_id , organization_id } }: any): SagaIterator {

    try {
        const invetations = yield call(apiInstance.post, `reporttool/usermanagement/user/accept-company-invitation`, {
            company_id,
        });
        console.log('invetationsinvetationsinvetations');
        console.log(invetations);
        console.log('invetationsinvetationsinvetationsinvetations');
        
        if (invetations?.data?.data) {
            yield put(companyAcceptInvetationSuccess(invetations?.data));
            yield put(getCompanyInvitationsToJoinOrganizations({
                company_id 
            }))
            return;
        }
        yield put(companyAcceptInvetationError('error'));

    } catch (error: any) {
        yield put(companyAcceptInvetationError('error'));
    }
}

// get company websites
function* getCompanyWebsitesSaga({ payload: { company_id , organization_id } }: any): SagaIterator {

    try {
        const websites = yield call(apiInstance.post, `reporttool/site/getbycompanyid`, { 
            company_id,
            // organization_id
        });
        if (websites.status == 200) {
            // console.log('websites?.data');
            // console.log(websites?.data);
            // console.log('websites?.data');
            
            yield put(getCompanyWebsiesSuccess(websites?.data));
            return;
        }
        yield put(getCompanyWebsiesError('error'));

    } catch (error: any) {
        yield put(getCompanyWebsiesError('error'));
    }
}

function* grantCompanyWebsiteAccessToOrganizationSaga({ payload: { company_id , organization_id , siteUUID  } }: any): SagaIterator {

    try {
        const access = yield call(apiInstance.post, `reporttool/organisationlevel/company/grant-company-website-access-to-organization`, {
            company_id,
            organization_id,
            siteUUID
        });
        const data = JSON.parse(access?.data)
        if ( data?.message ) {
            yield put(grantAccessToOrganizationSuccess(data?.message));
            return;
        }
        yield put(grantAccessToOrganizationError('Enable to Grant Access to Organization'));

    } catch (error: any) {
        yield put(grantAccessToOrganizationError('Enable to Grant Access to Organization Please Try Later'));
    }
}

// function* removeCompanyWebsiteAccessToOrganizationSaga({ payload: { company_id , organization_id , siteUUID  } }: any): SagaIterator {

//     try {
//         const access = yield call(apiInstance.post, `reporttool/organisationlevel/company/grant-company-website-access-to-organization`, {
//             company_id,
//             organization_id,
//             siteUUID
//         });

//         if (access) {
//             yield put(grantAccessToOrganizationSuccess(access?.data));
//             return;
//         }
//         yield put(grantAccessToOrganizationError('error'));

//     } catch (error: any) {
//         yield put(grantAccessToOrganizationError('error'));
//     }
// }


// get organization joined.
function* getOrganizationsJoinedSaga({ payload: { company_id   } }: any): SagaIterator {

    try {
        const organizations = yield call(apiInstance.post, `reporttool/organisationlevel/company/get-company-external-joined-organizations`, {
            company_id
        });

        if (organizations) {
            yield put(getJoinedOrganizationSuccess(organizations?.data));
            return;
        }
        yield put(getJoinedOrganizationeError('error'));

    } catch (error: any) {
        yield put(getJoinedOrganizationeError('error'));
    }
}

function* updateCompanyNameSaga({ payload: { new_company_name,company_id,isAccountPage , successMessage , errorCallback } }: PayloadAction<any>): SagaIterator {

    try {       
        yield put(updateCompanyNameSuccess(null));

        const updateCompanyName = yield call(apiInstance.put, isAccountPage == false ? 'reporttool/usermanagement/company/member-updates-company-name' : `reporttool/usermanagement/company/update-company-name` , {
           company_id,
           new_company_name
        });

        if(updateCompanyName?.data?.data){
            successMessage?.()
            yield put(updateCompanyNameSuccess(updateCompanyName.data.data));
            return
        }
        errorCallback?.(updateCompanyName?.data?.error ?? 'Enable To Update Company')
        yield put(updateCompanyNameError(updateCompanyName?.data?.message ?? 'Enable To Update Company'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(updateCompanyNameError(errorMessage));
    }
}

// get company websites
function* getInfoIndustrySaga(): SagaIterator {

    try {

        const user = yield select((state) => state.user.data);
        const tenantId = user.tenantId;

        const websites = yield call(apiInstance.post, `reporttool/organisationlevel/global/tenant/details/get`, {
            tenantId
        });

        if (websites) {
            yield put(getInfoIndustrySuccess(websites?.data));
            return;
        }
        yield put(getInfoIndustryError('error'));

    } catch (error: any) {
        yield put(getInfoIndustryError('error'));
    }
}


function* updateInfoIndustrySaga({ payload: { industry , successMessage  } }: PayloadAction<any>): SagaIterator {

    try {       
        const user = yield select((state) => state.user.data);
        const tenantId = user.tenantId;
        yield put(updateInfoIndustrySuccess(null));
        const updateCompanyName = yield call(apiInstance.post, `reporttool/organisationlevel/global/industry/update` , {
            tenantId,
            industry
        });
        
        if(updateCompanyName.status == 200){
            successMessage ?? successMessage()
            yield put(updateInfoIndustrySuccess(updateCompanyName.data));
            return;
        }
        yield put(updateInfoIndustryError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(updateInfoIndustryError(errorMessage));
    }
}


// get owen websites
 function*  getOwnCompaniesSaga() : SagaIterator   {

    try {
        
        // const user = yield select((state) => state.user.data);
        // const tenantId = user.tenantId;

        const companies = yield call(apiInstance.post, `/reporttool/usermanagement/company/getowncompanies`);
    
        
        if (companies?.data?.data) {
            yield put(getOwnCompaniesSuccess(companies?.data?.data));
            return;
        }
        yield put(getOwnCompaniesError('error'));

    } catch (error: any) {
        console.log(error);
        yield put(getOwnCompaniesError('error'));
    }
}

function* addCategorySaga({ payload: { company_id, category_name , submitCallback , errorCallback  } }: PayloadAction<any>): SagaIterator {

    try {   

        const result = yield call(apiInstance.post, `reporttool/usermanagement/category/add-category-to-company` , {
            company_id,
            category_name
        });
        
        if(result.status == 200 && result?.data?.data){
            submitCallback?.()
            yield put(addCategorySuccess(result.data.data));
            return;
        }
        const alertMessage = result?.data?.message ?? 'Enable to Create Category Please try again later'
        errorCallback?.(alertMessage)
        yield put(addCategoryError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'Enable to Create Category Please try again later';
        errorCallback?.(errorMessage)
        yield put(addCategoryError(errorMessage));
    }
  }


  function* updateCategorySaga({ payload: { category_id, new_category_name , errorCallback , submitCallback } }: PayloadAction<any>): SagaIterator {

    try {   
        

        const result = yield call(apiInstance.post, `reporttool/usermanagement/category/rename-category` , {
            category_id,
            new_category_name
        });       
        
        if(result.status == 200 && result?.data?.data){
            submitCallback?.()
            yield put(updateCategorySuccess(result.data.data));
            return;
        }
        const alertMessage = result?.data?.message ?? 'Unable to update category Please Try Later'
        errorCallback?.(alertMessage)
        yield put(updateCategoryError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'Unable to update category Please Try Later';
        errorCallback?.(errorMessage)
        yield put(updateCategoryError(errorMessage));
    }
  }



  function* deleteCategorySaga({ payload: { category_id , submitCallback , errorCallback  } }: PayloadAction<any>): SagaIterator {

    try {   

        const result = yield call(apiInstance.post, `reporttool/usermanagement/category/delete-category-from-company` , {
            category_id,
        });       
        
        if(result.status == 200){
            submitCallback?.()
            yield put(deleteCategorySuccess(result.data.data));
            return;
        }
        errorCallback?.('Enable To Delete Category')
        yield put(deleteCategoryError('error'));

    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'Enable To Delete Category';
        errorCallback?.('Enable To Delete Category')
        yield put(deleteCategoryError(errorMessage));
    }
  }

  // get owen company users
  function* getOwnCompanyUsersSaga({ payload: { company_id } }: PayloadAction<{ company_id: string }>): SagaIterator {
    try {
        const response = yield call(apiInstance.post, `/reporttool/usermanagement/user/get-company-users`, { company_id });
        const companyUsers = response?.data?.data;
        
        if (companyUsers) {
            console.log('Fetched company users:', companyUsers, 'for company ID:', company_id);
            yield put(getOwnCompanyUsersSuccess({ data: companyUsers, id: company_id }));
        } else {
            yield put(getOwnCompanyUsersError('No users found for this company.'));
        }
    } catch (error: any) {
        console.error('Failed to fetch company users:', error);
        yield put(getOwnCompanyUsersError('An error occurred while fetching company users.'));
    }
}


  // remove User From Company 
  function*  removeUserFromCompanySaga({ payload: { company_id, tenant_id  } }: PayloadAction<any>) : SagaIterator   {

    try {

        const result = yield call(apiInstance.post, `/reporttool/usermanagement/company/remove-user-from-company`,{company_id,user_tenant_id:tenant_id});      
         
        if (result?.data?.data) {
            yield put(removeUserFromCompanySuccess(result?.data?.data));
            return;
        }
        yield put(removeUserFromCompanyError('error'));

    } catch (error: any) {
        console.log(error);
        yield put(removeUserFromCompanyError('error'));
    }
}

  // remove User From Company 
  function*  assignComanyRoleSaga({ payload: { company_id, tenant_id,role  } }: PayloadAction<any>) : SagaIterator   {

    try {

        const result = yield call(apiInstance.post, `/reporttool/usermanagement/company/assign-company-role-to-user`,{
            user_tenant_id: tenant_id,
            company_id: company_id,
            role:role
        });      
         
        if (result?.data?.data) {
            yield put(assignComanyRoleSuccess(result?.data?.data));
            yield put(getOwnCompanyUsers({
                company_id:company_id,
            }));
            
            return;
        }
        yield put(assignComanyRoleError('error'));

    } catch (error: any) {
        console.log(error);
        yield put(assignComanyRoleError('error'));
    }
}


  // remove User From Company 
  function*  assignComanyPermissionSaga({ payload: { company_id, tenant_id,permission  } }: PayloadAction<any>) : SagaIterator   {

    try {

        const result = yield call(apiInstance.post, `/reporttool/usermanagement/company/assign-company-permissions-to-user`,{
            user_tenant_id: tenant_id,
            company_id: company_id,
            permissions:permission
        });                
        if (result?.data?.data) {
            yield put(assignComanyPermissionSuccess(result?.data?.data));
            return;
        }
        yield put(assignComanyPermissionError('error'));

    } catch (error: any) {
        console.log(error);
        yield put(assignComanyPermissionError('error'));
    }
}

// remove User From Company 
function*  assignWebSitePermissionSaga({ payload: { company_id, tenant_id,permission, siteUUID  } }: PayloadAction<any>) : SagaIterator   {

    try {

        const result = yield call(apiInstance.post, `/reporttool/usermanagement/company/assign-site-permissions-to-user`,{
            user_tenant_id: tenant_id,
            company_id: company_id,
            permissions:permission,
            siteUUID
        });      
        console.log('resultresultresult');
        console.log(result);
        console.log('resultresultresult');
          
        if (result?.data?.data) {
            yield put(assignWebSitePermissionSuccess(result?.data?.data));
            return;
        }
        yield put(assignWebSitePermissionError('error'));

    } catch (error: any) {
        console.log(error);
        yield put(assignWebSitePermissionError('error'));
    }
}  


function* watchOrganization() : Generator<StrictEffect, void> {
    yield takeLatest(addClientToOrganization.type, addClientToOrganizationSaga);
    yield takeLatest(getOrganizationClients.type, getOrganizationClientsSaga);
    yield takeLatest(getOrganisationInvitations.type, getOrganisationInvitationsSaga);
    yield takeLatest(addClientToOrganizationViaEmail.type, addClientToOrganizationUsingEmailSaga);
    yield takeLatest(addClientOrganization.type, requestToJoinOrganizationSaga);
    yield takeLatest(giveAccessToOrganization.type, giveAccessToOrganizationSaga);
    yield takeLatest(removeAccessToOrganization.type, removeAccessToOrganizationSaga);
    yield takeLatest(updateUsersPermissions.type, updateUsersPermissionsSaga);
    yield takeLatest(getOrganizationUsers.type, getOrganizationUsersSaga);
    yield takeLatest(acceptOrganisationInvitation.type, acceptOrganisationInvitationSaga);
    yield takeLatest(declineOrganisationInvitation.type, declineOrganisationInvitationSaga);
    yield takeLatest(deleteClientFromOrganisation.type, deleteClientFromOrganisationSaga);
    yield takeLatest(addUser.type, addUserSaga);
    yield takeLatest(removeUser.type, removeUserSaga);
    yield takeLatest(getOrganizationSites.type, getOrganizationSitesSaga);
    yield takeLatest(createClientOrganization.type, createOrganizationSaga);
    yield takeLatest(getClientOrganizations.type, getClientOrhanizations);
    yield takeLatest(fetchClientSiteList.type, fetchSiteListSaga);
    yield takeLatest(UpdateremoveAccessToOrganizationSaga.type, _UpdateremoveAccessToOrganizationSaga);
    yield takeLatest(currentUserOrganizationAuth.type, getCurrentUserOrganizationPermissionsSaga);
    yield takeLatest(deleteOrganizationfun.type, deleteOrganisationSaga);
    yield takeLatest(fetchCompanies.type, fetchCompaniesFunc);
    yield takeLatest(createCompany.type, createUserCompanySaga);
    yield takeLatest(inviteCompanyToOrganization.type, inviteCompanyToOrganisationSaga);
    yield takeLatest(getCompanyInvitationsToJoinOrganizations.type, getCompanyInvitationToJoinOrganizationSaga);
    yield takeLatest(companyDeclinesInvetation.type, declineOrganizationInvitationSaga);
    yield takeLatest(companyAcceptInvetation.type, acceptOrganizationInvitationSaga);
    yield takeLatest(getCompanyWebsies.type, getCompanyWebsitesSaga);
    yield takeLatest(grantAccessToOrganization.type, grantCompanyWebsiteAccessToOrganizationSaga);
    yield takeLatest(getJoinedOrganization.type, getOrganizationsJoinedSaga);
    yield takeLatest(updateCompanyName.type, updateCompanyNameSaga);
    yield takeLatest(getInfosIndustry.type, getInfoIndustrySaga);
    yield takeLatest(updateInfosIndustry.type, updateInfoIndustrySaga);
    yield takeLatest(getOwnCompanies.type, getOwnCompaniesSaga);
    yield takeLatest(addCategory.type, addCategorySaga);
    yield takeLatest(updateCategory.type, updateCategorySaga);
    yield takeLatest(deleteCategory.type, deleteCategorySaga);
    yield takeLatest(getOwnCompanyUsers.type, getOwnCompanyUsersSaga);
    yield takeLatest(removeUserFromCompany.type, removeUserFromCompanySaga);
    yield takeLatest(assignComanyRole.type, assignComanyRoleSaga);
    yield takeLatest(assignComanyPermission.type, assignComanyPermissionSaga);
    yield takeLatest(assignWebSitePermission.type, assignWebSitePermissionSaga);




}


export { watchOrganization };
